<template>
<div class="withdrawalEdit bgc padding-20">
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="formName" label-width="150px" class="demo-item" label-position="left" size="mini">
            <div class="classes blod">余额提现</div>
            <el-form-item label="可提现余额（元）：" prop="subject">
               {{withfrawal.pendingmoney}}
            </el-form-item>
            <el-form-item label="到账账户：" prop="subject">
                <div class="accounts">
                    <div class="account" :class="[item.cashtype==obj.code? 'icon_active': '']" @click="setType(obj)" v-for="(obj, index) in payType" :key="index">{{obj.name}}</div>
                </div>
            </el-form-item>
            <div class="account-detail" v-if="item.cashtype==1">
                <div class="account-info">
                    <span>发布方名称：{{user.username}}</span>
                    <!--<span>账户手机号：{{user.loginname}}</span>-->
                </div>
                <div class="tip tc-red">温馨提示:转至账户余额的票款不能在从余额提取出来!</div>
            </div>
            <div class="account-detail" v-if="item.cashtype==2">
                <el-form-item label="微信账号：" prop="accountno">
                    <el-input v-model.trim="item.accountno" placeholder="请输入微信账号" clearable></el-input>
                </el-form-item>
                <div class="tip tc-red">提现前请先绑定实名认证的微信号。绑定实名认证微信号的店铺每日能提现的上限为2万，不支持非实名认证微信号提现。</div>
            </div>
            <div class="account-detail" v-if="item.cashtype==3">
                <el-form-item label="真实姓名：" prop="accountname">
                    <el-input v-model.trim="item.accountname" placeholder="请输入真实姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="支付宝账号：" prop="accountno">
                    <el-input v-model.trim="item.accountno" placeholder="请输入支付宝账号" clearable></el-input>
                </el-form-item>
            </div>
            <div class="account-detail" v-if="item.cashtype==4">
                <el-form-item label="银行卡账号：" prop="accountno">
                    <el-input v-model.trim="item.accountno" placeholder="请输入银行卡账号" clearable></el-input>
                </el-form-item>
                <el-form-item label="开户姓名：" prop="accountname">
                    <el-input v-model.trim="item.accountname" placeholder="请输入开户姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="开户银行：" prop="bankname">
                    <el-input v-model.trim="item.bankname" placeholder="请输入开户银行" clearable></el-input>
                </el-form-item>
                <el-form-item label="开户城市：" prop="bankcity">
                    <el-input v-model.trim="item.bankcity" placeholder="请输入开户城市" clearable></el-input>
                </el-form-item>
                <el-form-item label="开户行分行：" prop="banksubname">
                    <el-input v-model.trim="item.banksubname" placeholder="请输入开户行分行" clearable></el-input>
                </el-form-item>
            </div>
            <el-form-item label="提现金额" prop="money" class="price">
                <el-input v-model.trim="item.money" placeholder="0.00" clearable></el-input>
                <!--<div>今日已提现：123元</div>-->
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">立即提现</el-button>
                <el-button type="" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {nationalDistribution} from 'api/message'
import {editHostCashApply, getStatisticsCashInfo} from 'api/nationalDistribution'
export default {
    name: 'withdrawalEdit',
    data() {
        let validateMoney = (rule, value, callback) => {
            if (this.withfrawal.pendingmoney < parseFloat(this.item.money)) {
                callback(new Error('提现金额不能大于可提现金额'))
            } else {
                callback()
            }
        }
        return {
            item: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : '',
                accountname: '',
                money: '',
                cashtype: 3,
                accountno: '',
                bankcity: '',
                banksubname: '',
                bankname: ''
            },
            withfrawal: 0,
            payType: [
                // {code: 1, name: '账户余额'},
                // {code: 2, name: '微信账户'},
                {code: 3, name: '支付宝'},
                {code: 4, name: '银行卡'}
            ],
            rules: {
                money: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'},
                    {pattern: /^(([1-9][0-9]*)|([1-9][0-9]*\.\d{1,2})|([0]\.[1-9]{1})|([0]\.0[1-9]{1})|([0]\.[1-9]{1}\d))$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'},
                    {validator: validateMoney, trigger: 'blur'}
                ],
                accountno: [
                    {required: true, message: '请输入账号', trigger: 'blur'}
                ],
                accountname: [
                    {required: true, message: '请输入姓名', trigger: 'blur'}
                ],
                bankcity: [
                    {required: true, message: '请输入开户城市', trigger: 'blur'}
                ],
                banksubname: [
                    {required: true, message: '请输入开户银行分行', trigger: 'blur'}
                ],
                bankname: [
                    {required: true, message: '请输入开户银行', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        if (this.item.eventinnerid) {
            this._getStatisticsCashInfo()
        } else {
            this.$message.error('请选择活动')
            this.$router.back()
        }
    },
    methods: {
        setType(obj) {
            this.item.cashtype = obj.code
        },
        cancel() {
            this.$confirm(nationalDistribution.cancelEdit.msg, nationalDistribution.cancelEdit.title, {
                confirmButtonText: nationalDistribution.cancelEdit.confirmText,
                cancelButtonText: nationalDistribution.cancelEdit.cancelText
            }).then(() => {
                this.$router.back()
            }).catch(() => {})
        },
        submitForm() {
            this.$refs.formName.validate((valid) => {
                if (valid) {
                    this.$confirm(nationalDistribution.addCashApply.msg, nationalDistribution.addCashApply.title, {
                        confirmButtonText: nationalDistribution.addCashApply.confirmText,
                        cancelButtonText: nationalDistribution.addCashApply.cancelText,
                        closeOnClickModal: false
                    }).then(() => {
                        this._addObject(this.item)
                    }).catch(() => {
                    })
                } else {
                    return false
                }
            })
        },
        _addObject(obj) {
            this.setLoading(true)
            editHostCashApply({
                data: Object.assign({}, obj),
                success: data => {
                    if (data.code === '301') {
                        this.$message.error(data.msg)
                    } else {
                        this.$message.success(nationalDistribution.addCashApply.successMsg)
                        this.setLoading(false)
                        this.setPage({page: 1, pageSize: 10})
                        this.$router.back()
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getStatisticsCashInfo() {
            this.setLoading(true)
            getStatisticsCashInfo({
                data: {eventinnerid: this.item.eventinnerid},
                success: data => {
                    this.withfrawal = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading',
            'user'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scpoed>
@import "~common/scss/variable";
@import "~common/scss/mixin";
.withdrawalEdit {
    .account-form{
        margin-top: 20px !important;
    }
    .accounts{
        @include flexBox(flex-start);
        .account{
            width: 180px;
            height: 50px;
            box-sizing: border-box;
            border: 1px solid $line;
            text-align: center;
            line-height: 50px;
            margin-right: 30px;
            border-radius: 4px;
            position: relative;
            &:before{
                width: 28px;
                height: 28px;
                position: absolute;
                top:0;
                left:0;
            }
        }
    }
    .account-detail{
        background: #F5F7FA;
        padding: 20px 32px;
        margin-left: 150px;
        margin-bottom: 20px;
        .account-info{
            @include flexBox(flex-start);
            margin-bottom: 20px;
            span{
                margin-right: 50px;
            }
        }
    }
    .price{
        .el-form-item__content{
            @include flexBox(flex-start);
        }
    }
    .el-input{
        width: 250px !important;
        margin-right: 30px;
    }
}
</style>
